export default {
  setRows(state, data) {
    state.rows = data
  },

  setRow(state, data) {
    state.row = data
  },

  setCustomTaxes(state, data) {
    state.customTaxes = data
  },
}
